var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: _vm.classNames,
      attrs: { href: _vm.href, download: _vm.download },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm._t("innerAnchorSlot", [
        _vm._v("\n\t\t" + _vm._s(_vm.anchorText) + "\n\t")
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }